import { z } from "zod";

import { GeneralErrorSchema } from "./schemas/error.schema";
import {
  AddQuoteVersionSchema,
  AddVariationSchema,
} from "./schemas/estimation.schema";
import { MultiSelectDefaultValuesSchema } from "./schemas/general.schema";

import {
  EOptionSchema,
  ForOptionsSchema,
} from "@/features/projectRegister/ProjectRegister.schema";
import { Permissions } from "@/interfaces/globals";

// import { EOption, forOptions } from "./schemas/project-register.schema";

export const OptionSchema = EOptionSchema.merge(
  z.object({ for: ForOptionsSchema }),
);

export const NewEstimateOptions = z.object({
  data: z.array(OptionSchema),
});

const PermissionSchema = z.object({
  workspace: z.string(),
  resource: z.nativeEnum(Permissions),
  action: z.string(),
  checked: z.boolean().optional(),
});

export const PermissionFormSchema = z.object({
  permissions: z.array(PermissionSchema),
});

export {
  AddQuoteVersionSchema,
  AddVariationSchema,
  GeneralErrorSchema,
  MultiSelectDefaultValuesSchema,
};
